export enum ERROR_CODE {
  // Validation
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INCORRECT_USERNAME_OR_PASSWORD = 401,
  FIELD_REQUIRED = 'FIELD_REQUIRED',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  INVALID_PASSWORD_LENGTH = 'INVALID_PASSWORD_LENGTH',
  INVALID_USERNAME = 'INVALID_USERNAME',
  INVALID_USERNAME_LENGTH = 'INVALID_USERNAME_LENGTH',
  FIELD_IS_INVALID = 'FIELD_IS_INVALID',
  FIELD_INTEGER_IS_INVALID = 'FIELD_INTEGER_IS_INVALID',
  INVALID_INTEGER = 'INVALID_INTEGER',
  INVALID_IP = 'INVALID_IP',
  INVALID_DATING_CURRENCY_VALUE = 'INVALID_DATING_CURRENCY_VALUE',
  INVALID_NUMBER_RANGE_INPUT = 'INVALID_NUMBER_RANGE_INPUT',

  // Affiliates profile transfer
  AFFILIATES_PROFILE_TRANSFER_PROFILE_NOT_FOUND = 1001,
  AFFILIATES_PROFILE_TRANSFER_REQUEST_BODY_REQUIRED = 1002,
  AFFILIATES_PROFILE_TRANSFER_REPEAT_DAYS_REQUIRED = 1003,
  AFFILIATES_PROFILE_TRANSFER_REPEAT_DAYS_INVALID = 1004,
  AFFILIATES_PROFILE_TRANSFER_REPEAT_DAYS_DUPLICATE = 1005,
  AFFILIATES_PROFILE_TRANSFER_END_DATE_REQUIRED = 1006,
  AFFILIATES_PROFILE_TRANSFER_END_DATE_INVALID = 1007,
  AFFILIATES_PROFILE_TRANSFER_DESTINATION_REQUIRED = 1008,
  AFFILIATES_PROFILE_TRANSFER_EMAIL_INVALID = 1009,
  AFFILIATES_PROFILE_TRANSFER_TIME_REQUIRED = 1010,
  AFFILIATES_PROFILE_TRANSFER_TIME_INTERVAL_INVALID = 1011,
  AFFILIATES_PROFILE_TRANSFER_USER_NOT_FOUND = 1012,

  // Dates
  DATES_REQUIRED = 'DATES_REQUIRED',
  DATE_INVALID = 'DATE_INVALID',
  START_DATE_INVALID_FORMAT = 'START_DATE_INVALID_FORMAT',
  END_DATE_INVALID_FORMAT = 'END_DATE_INVALID_FORMAT',
  DATE_RANGE_INVALID = 'DATE_RANGE_INVALID',
  END_DATE_OUT_OF_RANGE = 'END_DATE_OUT_OF_RANGE',

  // Withdrawals
  WITHDRAWAL_SYSTEM_NOTIFICATION_ERROR = 'WITHDRAWAL_SYSTEM_NOTIFICATION_ERROR',
  WITHDRAWAL_AUTO_CONFIRMATION_NOT_AVAILABLE = 'WITHDRAWAL_AUTO_CONFIRMATION_NOT_AVAILABLE',
  WITHDRAWAL_CARD_VALIDATION_ERROR = 'WITHDRAWAL_CARD_VALIDATION_ERROR',

  NOT_FOUND = 404,
  // Unexpected error
  UNEXPECTED_ERROR = 500,
}

export const ERROR_TEXTS_BY_CODE = {
  // Validation
  [ERROR_CODE.VALIDATION_ERROR]: 'Ошибка валидации',
  [ERROR_CODE.INCORRECT_USERNAME_OR_PASSWORD]: 'Неверный логин или пароль',
  [ERROR_CODE.FIELD_REQUIRED]: 'Поле обязательно для заполнения',
  [ERROR_CODE.INVALID_EMAIL]: 'Неверный формат email',
  [ERROR_CODE.INVALID_INTEGER]: 'Значение должно быть целым числом',
  [ERROR_CODE.INVALID_PASSWORD]: 'Неверный формат пароля',
  [ERROR_CODE.INVALID_PASSWORD_LENGTH]:
    'Пароль должен быть не менее 6 символов',
  [ERROR_CODE.INVALID_USERNAME]: 'Неверный формат имени',
  [ERROR_CODE.INVALID_USERNAME_LENGTH]: 'Имя должно быть не менее 2 символов',
  [ERROR_CODE.FIELD_IS_INVALID]: 'Поле заполнено неверно',
  [ERROR_CODE.FIELD_INTEGER_IS_INVALID]: 'Введите корректное число',
  [ERROR_CODE.INVALID_IP]: 'Неверный формат IP',
  [ERROR_CODE.INVALID_NUMBER_RANGE_INPUT]: 'Неверные значения диапазона',

  // Affiliates profile transfer
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_PROFILE_NOT_FOUND]:
    'Affiliate profile not found',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_REQUEST_BODY_REQUIRED]:
    'Request body is required',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_REPEAT_DAYS_REQUIRED]:
    'Select repeat days',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_REPEAT_DAYS_INVALID]:
    'Repeat days must contain values from 1 to 7',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_REPEAT_DAYS_DUPLICATE]:
    'Repeat days must not contain duplicates',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_END_DATE_REQUIRED]: 'Select end date',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_END_DATE_INVALID]:
    'End date cannot be earlier than today',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_DESTINATION_REQUIRED]:
    'Enter destination account',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_EMAIL_INVALID]:
    'Invalid email format',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_TIME_REQUIRED]:
    'Select execution time',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_TIME_INTERVAL_INVALID]:
    'Time interval between transfers must be at least 5 minutes',
  [ERROR_CODE.AFFILIATES_PROFILE_TRANSFER_USER_NOT_FOUND]:
    'User with this email not found',

  // Dates
  [ERROR_CODE.DATES_REQUIRED]: 'Необходимо ввести обе даты',
  [ERROR_CODE.DATE_INVALID]: 'Дата введена не корректно',
  [ERROR_CODE.END_DATE_OUT_OF_RANGE]:
    'Конечная дата не может быть больше текущей',
  [ERROR_CODE.DATE_RANGE_INVALID]: 'Неверный диапазон дат',
  [ERROR_CODE.START_DATE_INVALID_FORMAT]: 'Начальная дата введена неверно',
  [ERROR_CODE.END_DATE_INVALID_FORMAT]: 'Конечная дата введена неверно',

  // Withdrawals
  [ERROR_CODE.WITHDRAWAL_SYSTEM_NOTIFICATION_ERROR]:
    'Ошибка получения системных уведомлений',
  [ERROR_CODE.WITHDRAWAL_AUTO_CONFIRMATION_NOT_AVAILABLE]:
    'Не удалось получить данные автоматического подтверждения запросов на вывод средств',

  [ERROR_CODE.WITHDRAWAL_CARD_VALIDATION_ERROR]:
    'Счет карты или кошелька должен содержать от 4 до 50 символов',

  // Payments
  [ERROR_CODE.INVALID_DATING_CURRENCY_VALUE]: 'Введите число от 1 до 999',

  [ERROR_CODE.NOT_FOUND]: 'Запрашиваемый ресурс не найден',
  // Unexpected error
  [ERROR_CODE.UNEXPECTED_ERROR]: 'Произошла непредвиденная ошибка.',
};

export const ERROR_NAME = {
  NOT_ALLOWED_ERROR: 'NotAllowedError',
  NOT_FOUND_ERROR: 'NotFoundError',
  NOT_READABLE_ERROR: 'NotReadableError',
  OVERCONSTRAINED_ERROR: 'OverconstrainedError',
  TYPE_ERROR: 'TypeError',
};
